import { isSupportedBrowser } from '@/utils/supportedBrowser'

const getRedirectUrl = () => {
  if (!document.referrer) {
    return '/'
  }

  if (new URL(document.referrer).origin === document.location.origin) {
    return document.referrer
  }

  return '/'
}

const onContinue = () => {
  document.location.assign(getRedirectUrl())
}

const checkBrowser = () => {
  if (isSupportedBrowser()) {
    onContinue()
  } else {
    const continueButton = document.getElementById('continue-btn')
    if (continueButton) {
      continueButton.addEventListener('click', () => {
        onContinue()
      })
    }
  }
}

checkBrowser()
